<template>
  <!-- Display messages driver chat -->
  <div class="justify-content-md-center">
    <b-row>
      <b-col cols="12" class="mb-1 d-flex justify-content-end">
        <b-form-checkbox
          v-model="localTime"
          value="accepted"
          class="mr-2"
          @change="changeToLocaltimeZone($event)"
        >
          {{ $t('tracking.localTime') }}
        </b-form-checkbox>
        <b-button variant="primary" class="btn-sm" 
          v-b-tooltip.hover :title="$t('globals.reload') + 'chat'"
          @click="reloadConversation">
          <md-icon icon="update"/>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4">
        <div class="bg-light border text-center h-100 p-2">
          <div v-if="driver == null">{{ $t('driver.withoutDriverData') }}</div>
          <div v-if="driver != null">
            <div class="d-flex justify-content-between px-3 tp-3">
              <div class="font-weight-bolder">{{ $t('users.name') }}: </div> 
              <div>{{ driver.firstName }} {{ driver.lastName }}</div>
            </div>
            <div class="d-flex justify-content-between px-3">
              <div class="font-weight-bolder">{{ $t('users.phone') }}: </div> 
              <div>{{ driver.phone }}</div>
            </div>
            <div class="d-flex justify-content-between px-3">
              <div class="font-weight-bolder">{{ $t('users.email') }}: </div> 
              <div>{{ driver.email }}</div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="8">
        <div class="chat chat-container">
          <div class="chat-messages">

            <!-- Contenedor de mensajes -->
            <div class="chat__messages" aria-live="polite" v-if="loading == false">
              <!-- Componente de mensaje receptor -->
              <article
                v-for="(message, index) in messages"
                :key="index"
                :class="['message', 'message--'+message.userType]">
                  <h3 class="message__username">
                    {{ message.userType ==  'client' ? $t('bookings.client') : $t('bookings.driver') }}:
                  </h3>
                  <p class="message__text">{{ message.content  }}</p>
                  <div class="message__datetime text-right">
                    <md-icon v-if="message.seen" icon="done_all"/>
                    {{ message.dateTimeString  }}
                  </div>
              </article>
            </div>

            <div class="text-center p-3 text-muted" v-if="messages.length == 0 && loading == false">
              {{ $t('messages.chatNotAvailable') }}
            </div>
                    <!-- Loading -->
            <div v-if="loading" class="col-12 text-center pt-5">
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
              <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            </div>
        <!-- End Loading -->
        
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import api from "../../../../api.js";
var moment = require('moment-timezone');

export default {
  name: 'Chat',
  props: {
    transportServiceId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      messages: [],
      driver: null,
      localTime: false,
      timeZoneName: null,
      loading: false
    }
  },
  methods: {
    getConversation() {
      this.loading = true
      api(this)
				.get("/driver/transport-services/chat/" + this.transportServiceId)
				.then(res => {
          this.timeZoneName = res.data.timezone
					this.messages     = this.processMessages(res.data.messages)
          this.driver       = res.data.driver
				})
				.finally(() => {
          this.loading = false;
				});
    },
    parseDate(date) {

      var datetime = new Date(0)
      datetime.setUTCSeconds(date._seconds)
      if (this.localTime == false && this.timeZoneName != null) {
        datetime = datetime.toLocaleString('en-US', {timeZone: this.timeZoneName})
      }
      let dateStr = moment.parseZone(datetime);

      return dateStr
    },
    formatDateTime(date) {
      return date.format("DD/MMMM/YYYY HH:mm");
    },
    processMessages(messages) {
      let messagesConversation = []
      messages.forEach(message => {
        let dateTime = this.parseDate(message.createdAt)
        message      = { ...message, ...{
          dateTime: dateTime, 
          dateTimeString: this.formatDateTime(dateTime)
        }}
        messagesConversation.push(message)
      })

      messagesConversation.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.dateTime) - new Date(b.dateTime);
      })

      return messagesConversation
    },
    reloadConversation() {
      // Reload conversation
      this.getConversation()
    },
    changeToLocaltimeZone() {
      this.messages = this.processMessages(this.messages)
    }
  },
  mounted() {
    this.getConversation()
  },
}
</script>

<style>

.chat-container {
  max-width: 100%;
  max-height: 450px;
  overflow-y: scroll;
}

/** CUSTOM CSS CHAT */
:root {
    /* Colors */
    --color-black: #1D1E21;
    --color-white: #FFF;
    --color-background: #E8E8E8;
    --color-green: #43B72A;

    /* Fonts */
    --font-body: Arial;

    /* Gaps */
    --gap-s: 0.9rem;
    --gap-m: 1rem;
    --gap-l: 1.5rem;
    --gap-xl: 2rem;
    --gap-xxl: 3rem;
}

/* Animaciones */
@keyframes ani-pulse {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

/* Generales */
body {
    font-family: var(--font-body);
}

/* Componentes */
.chat {
    background-color: var(--color-white);
    border-top-left-radius: var(--gap-l);
    border-top-right-radius: var(--gap-l);
    .chat__header {
        background-color: var(--color-black);
        border-top-left-radius: var(--gap-l);
        border-top-right-radius: var(--gap-l);
        padding: var(--gap-m);
        box-sizing: border-box;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: -2rem;
            height: 2rem;
            background-image: linear-gradient(var(--color-background), transparent);
            z-index: 10;
        }
    }
    .chat__close {
        display: block;
        margin-left: auto;
    }
    .chat__name {
        margin: 0;
        font-size: var(--gap-l);
        font-weight: normal;
        margin-bottom: .4rem;
    }
    .chat__status {
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
            white-space: initial;
            overflow: initial;
            text-overflow: initial;
        }
    }
    .chat__messages {
        padding-inline: var(--gap-s);
        overflow-y: auto;
        background-color: var(--color-background);
    }
    .message {
        width: 14rem;
        padding: var(--gap-m);
        margin-block: var(--gap-l);
        border-radius: var(--gap-s);
        position: relative;
        margin-left: auto;
        &::before {
            --lado: 0;
            display: block;
            content: "";
            width: var(--lado);
            height: var(--lado);
            position: absolute;
            bottom: -12px;
            right: 1rem;
            transform: rotate(-136deg);
            border: 1rem solid #4f39cf;
            border-left-color: transparent;
            border-bottom-color: transparent;
            border-right-color: transparent;
        }

    .message__username {
        font-weight: normal;
        margin: 0;
        font-size: var(--gap-m);
    }

    .message__text {
        margin: 0;
        margin-top: var(--gap-s);
        font-size: var(--gap-s);
    }

    .message__datetime {
      font-size: 10px;
    }

    }
    .message--driver {
        margin-left: initial;
        color: white;
        background-color: #4f39cf;
        &::before {
            right: 0;
            left: 1rem;
            transform: rotate(275deg);
            bottom: -16px;
            border: 1rem solid #4f39cf;
            border-left-color: transparent;
            border-bottom-color: transparent;
            border-right-color: transparent;
        }
    }
    .message--client {
        margin-right: initial;
        background-color: #f4f4f4;
        &::before {
            right: 0;
            left: 11rem;
            transform: rotate(90deg);
            bottom: -16px;
            border: 1rem solid #f4f4f4;
            border-left-color: transparent;
            border-bottom-color: transparent;
            border-right-color: transparent;
        }
    }
}

</style>